import React from 'react';
import SupportTicketConfigurationsSection from '../../../sections/AdminDashboard/Configuration/SupportTicketConfigurations';

const SupportTicket = () => <SupportTicketConfigurationsSection />;

export default SupportTicket;
